import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';
import { IFacilityInvitationMessages } from '../../entities/FacilityInvitationMessages/FacilityInvitationMessages.ts';

export class FacilityInvitationMessagesApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/HealthcareFacilities`;

    public static apiUrls = {
        getByFacility: `${FacilityInvitationMessagesApi.baseApiUrl}/:id/InvitationMessages`,
        save: `${FacilityInvitationMessagesApi.baseApiUrl}/:id/InvitationMessages`,
        sendTest: `${BaseApi.apiUrl}/Tests/send-test-invitation`,
    };

    public static async getByFacility(facilityId: number): Promise<IFacilityInvitationMessages> {
        return this.sendApiRequest<IFacilityInvitationMessages>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getByFacility,
            data: undefined,
            id: facilityId.toString(),
        });
    }

    public static async save(
        facilityId: number,
        messages: IFacilityInvitationMessages,
    ): Promise<void> {
        return this.sendApiRequest<void>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.save,
            data: messages,
            id: facilityId.toString(),
        });
    }

    public static async reset(facilityId: number, language: string): Promise<void> {
        return this.sendApiRequest<void>({
            method: HttpMethodEnum.DELETE,
            path: `${this.baseApiUrl}/${facilityId}/InvitationMessages/${language}`,
        });
    }

    public static async sendTestInvitation(
        language: string,
        bodyHtml: string,
        facilityId?: number,
    ): Promise<void> {
        return this.sendApiRequest<void>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.sendTest,
            data: { language, bodyHtml, facilityId },
        });
    }
}
